import { Button } from '@material-ui/core';
import { useReducer } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import TextInput from '../../../../lib/TextField';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK } from '../../../../redux-store/types/nct';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import { BANK_ACCOUNT_DETAILS, OTP_ACTIONS } from '../../../../utils/constants';
import { ActionHeader, FaqLink } from '..';
const { dashboard } = en;

const ADD_BANK = 'addition';
const DELETE_BANK = 'deletion';
const CHANGE_DEFALUT = 'changeDefaultFlag';

type State = {
    targetFunds: ConsolidateTableRowType[];
    addedBank?: BANK;
    deletedBank?: BANK;
    changedDefaultBank?: BANK;
};
type Action = {
    type: string;
};
const _actionReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case ADD_BANK: {
            return state;
        }
        case DELETE_BANK: {
            return state;
        }
        case CHANGE_DEFALUT: {
            return state;
        }
        default:
            throw new Error('');
    }
};

function BankMandateSelected(props: any) {
    const { targetFunds = [] }: { targetFunds: ConsolidateTableRowType[] } =
        props.location.state || {};
    const [actionType, setActionType] = useState<string | undefined>('');
    const [state, dispatch] = useReducer(_actionReducer, { targetFunds });

    const handleSubmit = async () => {
        if (actionType === ADD_BANK) {
            props.history.replace('bank-mandate-add-bank', {
                targetFunds: state.targetFunds,
                actionType,
                addBank: true,
            });
            return;
        }
        const { pan, pekrn, mobile } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.updateMultipleBanks,
            });
            props.history.replace('bank-mandate-otp', {
                targetFunds: state.targetFunds,
                mobile,
                actionType,
                ...(res || {}).body,
                addBank: false,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.BankMandate.BankMandateHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <p>{dashboard.BankMandate.selectedFolios.subheading}</p>
                        {state.targetFunds?.map((fund: ConsolidateTableRowType) => (
                            <div className="selected-folios-list">
                                <h3>{fund.amcName}</h3>
                                <a className="delete-folio" href="#">
                                    <img src="/images/delete-folio.svg" alt="delete icon" />
                                </a>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.BankMandate.selectedFolios.primaryHolder}
                                        <span>{fund.investorName}</span>
                                    </p>
                                    <p>
                                        {dashboard.BankMandate.selectedFolios.ifsc}
                                        <span>
                                            {
                                                fund.bank?.find((detail) => detail.default === 'Y')
                                                    ?.ifsc
                                            }
                                        </span>
                                    </p>
                                    <p>
                                        {dashboard.BankMandate.selectedFolios.bankName}
                                        <span>
                                            {
                                                fund.bank?.find((detail) => detail.default === 'Y')
                                                    ?.name
                                            }
                                        </span>
                                    </p>
                                    <p>
                                        {dashboard.BankMandate.selectedFolios.folioNo}
                                        <span>{fund.folio}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="add-new-bankAccount bank-mandate-radio-group">
                        <CustomRadio
                            extraClass="change-tax-radio"
                            name="bank-mandate-account"
                            list={[
                                {
                                    label: dashboard.BankMandate.selectedFolios.radioOption1,
                                    value: ADD_BANK,
                                },
                                {
                                    label: dashboard.BankMandate.selectedFolios.radioOption2,
                                    value: DELETE_BANK,
                                },
                                {
                                    label: dashboard.BankMandate.selectedFolios.radioOption3,
                                    value: CHANGE_DEFALUT,
                                },
                            ]}
                            selectedValue={actionType}
                            handleRadioChange={(value: any) => setActionType(value)}
                        />
                        <FaqLink section={BANK_ACCOUNT_DETAILS} history={props.history} />
                        <Button onClick={handleSubmit} className="customBtn">
                            {dashboard.BankMandate.selectedFolios.next}
                        </Button>
                    </div>
                    {/* <div className="add-new-bankAccount">
                        <h4>{dashboard.BankMandate.selectedFolios.addNewBankHeading}</h4>
                        <div className="new-bank-fields">
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.accountNumber}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.ifsc}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.bankName}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.accountType}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.branch}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.BankMandate.selectedFolios.fields.city}
                            />
                        </div>
                        <Button href="/portal/nct/change-bank-success" className="customBtn">
                            {dashboard.BankMandate.selectedFolios.save}
                        </Button>
                    </div> */}
                    {/* <div className="curved-bg-content-inner-bottom">
                        <h4>{dashboard.BankMandate.selectedFolios.uploadDocuments}</h4>
                        <p>{dashboard.BankMandate.selectedFolios.uploadDocumentsInfo}</p>
                        <div className="selected-folios-btn bank-selected-folios-bottom">
                            <div className="change-bank-upload">
                                <p>{dashboard.BankMandate.selectedFolios.defaultBank}</p>
                                <div className="bank-selected-upload-fields">
                                    <UploadFile />
                                    <div className="pan-verification">
                                        <div className="name-validation">
                                            <p className="validating">
                                                <div className="spinner"></div>
                                                <span>
                                                    {
                                                        dashboard.BankMandate.selectedFolios
                                                            .ocrDataValidating
                                                    }
                                                </span>
                                            </p>
                                            <p className="successful">
                                                <img src="/images/green-tick.svg" alt="icon" />
                                                <span>
                                                    {
                                                        dashboard.BankMandate.selectedFolios
                                                            .ocrDataSuccess
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p>{dashboard.BankMandate.selectedFolios.newBank}</p>
                                <div className="bank-selected-upload-fields">
                                    <UploadFile />
                                    <div className="pan-verification">
                                        <div className="name-validation">
                                            <p className="validating">
                                                <div className="spinner"></div>
                                                <span>
                                                    {
                                                        dashboard.BankMandate.selectedFolios
                                                            .bankValidating
                                                    }
                                                </span>
                                            </p>
                                            <p className="failed">
                                                <img src="/images/close-red.svg" alt="icon" />
                                                <span>
                                                    {' '}
                                                    {
                                                        dashboard.BankMandate.selectedFolios
                                                            .bankValidationFailed
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="validation-failed-info">
                                <div className="name-validation">
                                    <p className="failed">
                                        <img src="/images/close-red.svg" alt="icon" />
                                        <span>
                                            {dashboard.BankMandate.selectedFolios.ocrDataFailed}
                                        </span>
                                    </p>
                                </div>
                                <p className="failed-info">
                                    {dashboard.BankMandate.selectedFolios.ocrDataFailedInfo}
                                </p>
                                <a href="#">
                                    {dashboard.BankMandate.selectedFolios.uploadRequestLetter}
                                </a>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), { sendPhoneOTP })(
    BankMandateSelected,
);
